// Help

$(function () {
  $('.jsBlockHelpCarousel').owlCarousel({
    loop: true,
    nav: true,
    navText:[
      "<svg class=\"icon-chevron-left\"><use xlink:href=\"#icon-chevron-left\"></use></svg>",
      "<svg class=\"icon-chevron-right\"><use xlink:href=\"#icon-chevron-right\"></use></svg>"
    ],
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      1200: {
        items: 3
      }
    },
    smartSpeed: 500,
    autoplay: false,
    autoplayTimeout: 6000,
    autoplayHoverPause: true
  });
})
